// frontend/src/utils/slotAvailabilityNotice.js
//
// The message a customer sees when the time they picked is no longer available.
//
// Live in one place because BOTH booking flows show it (CustomerBooking and
// FreelancerBooking) and they must not drift. It also has to do three jobs, since
// for the customer it is the only thing on screen at that moment:
//
//   1. say what happened, without blaming them
//   2. reassure them that nothing was charged - they may have been sitting on the
//      payment step when this came back
//   3. tell them what to do next
//
// The server sends a stable `code` plus a general-purpose `message`; the wording
// the customer reads is owned here.

const SLOT_TAKEN_CODE = "slot_taken";

export function buildSlotUnavailableNotice(code, serverMessage) {
  const explanation =
    code === SLOT_TAKEN_CODE
      ? "Sorry, another customer just booked that time while you were checking out."
      : `${String(serverMessage || "That time is no longer available").replace(
          /\.+$/,
          "",
        )}.`;

  return `${explanation} Nothing has been charged \u2014 please choose a different time to continue.`;
}

export default buildSlotUnavailableNotice;
